/**
 * Przyklejanie kolumny zakupowej na karcie produktu - bez biblioteki.
 *
 * Zachowanie (decyzja usera, 24 sie 2026): kolumna lapie sie GORA od razu, jej
 * gora stoi 24 px pod krawedzia okna przez caly przewijany kadr, a dol kolumny
 * pokazuje sie dopiero na koncu karty - wtedy koniec kontenera wypycha ja w gore.
 *
 * Wczesniej dla kolumny wyzszej niz okno liczony byl UJEMNY odstep od gory, zeby
 * przykleic sie dolem. Skutkiem bylo zaczepienie dopiero po przewinieciu roznicy
 * wysokosci (na karcie narozinka 690 px) - kolumna dlugo jechala ze strona, a
 * potem lapala sie tak nisko, ze widac bylo wylacznie jej dolna czesc.
 *
 * Ponizej 992 px przyklejanie jest wylaczone.
 */
if (!customElements.get('pdp-sticky-column')) {
  class PdpStickyColumn extends HTMLElement {
    connectedCallback() {
      this.inner = this.querySelector('[data-pdp-sticky]');
      if (!this.inner) return;

      this.topSpacing = parseInt(this.dataset.topSpacing || '24', 10);
      this.bottomSpacing = parseInt(this.dataset.bottomSpacing || '24', 10);
      this.media = window.matchMedia('(min-width: 992px)');

      this.update = this.update.bind(this);

      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.inner);
      window.addEventListener('resize', this.update, { passive: true });
      this.media.addEventListener('change', this.update);

      this.update();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('resize', this.update);
      if (this.media) this.media.removeEventListener('change', this.update);
    }

    update() {
      if (!this.media.matches) {
        this.style.removeProperty('--pdp-sticky-top');
        return;
      }

      /* Dwa przypadki, bo `position: sticky` umie trzymac tylko JEDNA krawedz.

         1. Kolumna MIESCI SIE w oknie - trzymamy ja gora, `top: 24px`.

         2. Kolumna jest WYZSZA od okna - trzymanie gory oznacza, ze jej dol
            jest nieosiagalny: tresc pod spodem nigdy nie wjezdza w kadr.
            Dajemy wiec UJEMNY `top`, rowny nadwyzce wysokosci. Kolumna
            przewija sie razem ze strona, az jej dol zrowna sie z dolem okna,
            i dopiero wtedy sie zatrzymuje.

         To jest zachowanie z micadoni.com (zgloszenie 7.09.2026: "prawa
         strona jak przewijam to zjezdza do swojej dolnej czesci").

         Robione TU, a nie przez wlaczenie `sticky_column` i biblioteki
         sticky-sidebar: komentarz w main-product.liquid tlumaczy, ze przy tej
         kolumnie biblioteka przewija z opoznieniem ("gonienie" tekstu).
         Sprawdzone 7.09 - po wlaczeniu przyklejanie w ogole przestalo
         dzialac. Natywny `sticky` nie ma tego problemu, bo nie liczy nic
         w JS przy kazdej klatce przewijania. */
      const wysokosc = this.inner.offsetHeight;
      const okno = window.innerHeight;
      const miesciSie = wysokosc + this.topSpacing + this.bottomSpacing <= okno;

      const top = miesciSie
        ? this.topSpacing
        : okno - wysokosc - this.bottomSpacing;

      this.style.setProperty('--pdp-sticky-top', Math.round(top) + 'px');
    }
  }

  customElements.define('pdp-sticky-column', PdpStickyColumn);
}
